import Component from '@Component';
import { lazyLoadIframeInModal } from '@Utility';

export default class YouTubePlayerWrapper extends Component {
  static loaderPriority = 'in-view'
  static selector = '[data-comp-youtube-player-wrapper]'

  constructor(containerEl) {
    super(containerEl);
    this.player = [];
    this.modal = this.$container.closest('[data-comp-modal]');
    this.modalCloseTrigger = this.modal.querySelector('[data-comp-modal-close-trigger]');
    this.playerFrame = this.$container.querySelector('iframe');
    this.iframeApiScriptSrc = 'https://www.youtube.com/iframe_api';
    this.onYouTubeIframeAPIReadyCallbacks = [];
    lazyLoadIframeInModal(this.playerFrame, () => {
      this.init();
    });
  }

  /* eslint-disable no-undef */
  init() {
    if (window.hideYTActivated) return;

    this.addIframeApiScript();
    this.addIframeAPIReadyListener();
    this.addModalCloseTriggerListener();
    this.addContainerClickHandler();
    this.addPlayerStateChangeListener();

    window.hideYTActivated = true;
  }

  addPlayerStateChangeListener() {
    const onPlayerStateChange = (event) => {
      if (event.data === YT.PlayerState.ENDED) {
        this.$container.classList.add('ended');
      } else if (event.data === YT.PlayerState.PAUSED) {
        this.$container.classList.add('paused');
      } else if (event.data === YT.PlayerState.BUFFERING) {
        this.$container.classList.remove('ended');
        this.$container.classList.remove('paused');
      } else if (event.data === YT.PlayerState.PLAYING) {
        setTimeout(() => {
          this.$container.classList.remove('ended');
          this.$container.classList.remove('paused');
        }, 250);
      }
    };

    this.onYouTubeIframeAPIReadyCallbacks.push(() => {
      this.player = new YT.Player(this.playerFrame, {
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    });
  }

  addIframeAPIReadyListener() {
    window.onYouTubeIframeAPIReady = () => {
      for (let t = 0; t < this.onYouTubeIframeAPIReadyCallbacks.length; t += 1) {
        this.onYouTubeIframeAPIReadyCallbacks[t]();
      }
    };
  }

  addContainerClickHandler() {
    this.$container.addEventListener('click', () => {
      const playerState = this.player.getPlayerState();

      if (playerState === YT.PlayerState.ENDED) {
        this.player.seekTo(0);
      } else if (playerState === YT.PlayerState.PAUSED) {
        this.player.playVideo();
      }
    });
  }

  addModalCloseTriggerListener() {
    this.modalCloseTrigger.addEventListener('click', () => {
      this.player.pauseVideo();
    });
  }

  addIframeApiScript() {
    const firstScriptTag = document.getElementsByTagName('script')[0];

    if (firstScriptTag.src !== this.iframeApiScriptSrc) {
      const tag = document.createElement('script');
      tag.src = this.iframeApiScriptSrc;

      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
  /* eslint-enable no-undef */
}
